<div class="d-flex justify-content-between product-dialog">
  <div>
    <div class="font-weight-bold space-left dialog-title">
      Raamsticker <span class="product-number">#{{ index + 1 }}</span>
    </div>
    <div class="space-right">
      <i>€ {{ productPrice }} (excl. BTW)</i>
    </div>
  </div>
  <div (click)="close()" class="close">
    <mat-icon svgIcon="close"></mat-icon>
  </div>
</div>
<hr />
<div class="d-flex">
  <div class="flexer right-space">
    <div class="space-top under-space">
      <span class="font-weight-bold">Attributen</span>
      <ul>
        <li><b>Titel</b>: {{ getTitle(inputWindowSticker.title) }}</li>
        <li>
          <b>{{
            inputWindowSticker.phoneNumbers.length > 1 ||
            (inputWindowSticker.phoneNumbers.length === 1 &&
              inputWindowSticker.otherPhone != null &&
              inputWindowSticker.otherPhone !== '')
              ? 'Telefoonnummers'
              : 'Telefoonnummer'
          }}</b
          >:
          <span
            *ngFor="
              let phone of inputWindowSticker.phoneNumbers;
              let i = index;
              let last = last
            "
            >{{
              (!last &&
                inputWindowSticker.phoneNumbers != null &&
                  inputWindowSticker.phoneNumbers.length > 0) ||
              (inputWindowSticker.otherPhone != null &&
                inputWindowSticker.otherPhone !== '')
                ? (phone | asFormatPhoneNumber) + ', '
                : (phone | asFormatPhoneNumber)
            }}</span
          >
          <span
            *ngIf="
              inputWindowSticker.otherPhone != null &&
              inputWindowSticker.otherPhone !== ''
            "
          >
            {{ inputWindowSticker.otherPhone }}
          </span>
          <span
            *ngIf="
              (inputWindowSticker.phoneNumbers == null ||
                inputWindowSticker.phoneNumbers.length == 0) &&
              (inputWindowSticker.otherPhone == null ||
                inputWindowSticker.otherPhone === '')
            "
          >
            Geen telefoonnummer
          </span>
        </li>
        <li>
          <b>Tekst</b>:
          {{
            inputWindowSticker.text == null || inputWindowSticker.text === ''
              ? 'Geen tekst'
              : inputWindowSticker.text
          }}
        </li>
      </ul>
    </div>

    <div class="under-space">
      <span class="font-weight-bold">Type folie</span>
      <div *ngIf="inputWindowSticker.temporaryMaterial != null">
        {{ inputWindowSticker.temporaryMaterial ? 'Tijdelijk' : 'Permanent' }}
      </div>
      <div *ngIf="inputWindowSticker.temporaryMaterial == null">
        Geen type opgegeven
      </div>
    </div>

    <div class="under-space">
      <span class="font-weight-bold">Afmetingen (h x b)</span>
      <div *ngIf="inputWindowSticker.requestedProductSize">
        {{ inputWindowSticker.requestedProductSize.height }}cm x
        {{ inputWindowSticker.requestedProductSize.width }}cm
      </div>
      <div *ngIf="!inputWindowSticker.requestedProductSize">
        Geen afmetingen opgegeven
      </div>
    </div>

    <div class="under-space">
      <span class="font-weight-bold">Definitief ontwerp</span>
      <div *ngIf="definitiveDesign != null && definitiveDesign.length !== 0">
        <span
          *ngFor="
            let asset of definitiveDesign;
            let last = last;
            let first = first
          "
        >
          <a
            class="click-link"
            download="{{ asset.name }}"
            href="/api/assets/{{ asset.uuid }}"
          >
            {{ first && !last ? asset.name + ', ' : asset.name }}
          </a>
        </span>
      </div>
      <div *ngIf="definitiveDesign == null || definitiveDesign.length === 0">
        Geen ontwerp opgegeven
      </div>
    </div>

    <div class="under-space">
      <span class="font-weight-bold">Extra info omtrent ontwerp</span>
      <div>
        {{
          inputWindowSticker.layoutDescription == null ||
          inputWindowSticker.layoutDescription === ''
            ? 'Geen extra info opgegeven'
            : inputWindowSticker.layoutDescription
        }}
      </div>
    </div>
  </div>

  <div class="flexer">
    <mat-card class="mat-elevation-z0 product-info">
      <div class="d-flex under-space">
        <div class="font-weight-bold">Afmetingen raam (h x b)</div>
        <div class="flex-grow-1 data-item">
          {{
            inputWindowSticker.windowLength != null
              ? inputWindowSticker.windowLength
              : '-'
          }}cm x
          {{
            inputWindowSticker.windowWidth != null
              ? inputWindowSticker.windowWidth
              : '-'
          }}cm
        </div>
      </div>

      <div class="under-space">
        <div class="font-weight-bold">Uitlijning sticker</div>
        <div>
          {{
            placement?.alignment == null
              ? 'Geen informatie opgegeven'
              : placement.alignment
          }}
        </div>
      </div>

      <div class="d-flex under-space">
        <div class="font-weight-bold">Materiaalkeuze</div>
        <div class="flex-grow-1 data-item">
          {{
            inputWindowSticker.foil != null
              ? inputWindowSticker.foil.name
              : 'Geen informatie'
          }}
        </div>
      </div>

      <div class="d-flex under-space">
        <div class="font-weight-bold">Laminaat</div>
        <div class="flex-grow-1 data-item">
          {{
            inputWindowSticker.laminate != null
              ? inputWindowSticker.laminate.name
              : 'Geen informatie'
          }}
        </div>
      </div>

      <div class="d-flex under-space">
        <div class="font-weight-bold">Immoscoop</div>
        <div class="flex-grow-1 data-item">
          <mat-icon
            *ngIf="isImmoscoop"
            svgIcon="check"
            style="transform: scale(0.5)"
          ></mat-icon>
          <mat-icon
            *ngIf="!isImmoscoop"
            svgIcon="close"
            style="transform: scale(0.5)"
          ></mat-icon>
        </div>
      </div>

      <div class="d-flex under-space">
        <div class="font-weight-bold">Spotto</div>
        <div class="flex-grow-1 data-item">
          <mat-icon
            *ngIf="isSpotto"
            svgIcon="check"
            style="transform: scale(0.5)"
          ></mat-icon>
          <mat-icon
            *ngIf="!isSpotto"
            svgIcon="close"
            style="transform: scale(0.5)"
          ></mat-icon>
        </div>
      </div>

      <div class="d-flex under-space">
        <div class="font-weight-bold">Kleuren</div>
        <div class="flex-grow-1 data-item">
          {{ getColors() }}
        </div>
      </div>

      <div class="d-flex under-space">
        <div class="font-weight-bold">Kleefinstructies</div>
        <div class="flex-grow-1 data-item">
          {{ placement?.inside ? 'Binnenkant' : 'Buitenkant' }}
        </div>
      </div>
    </mat-card>
  </div>
</div>
